import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";

import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";

import FormRow from "../../components/Row/FormRow";
import SelectRow from "../../components/Select/SelectRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";

export default class ClientAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      _id: "",
      title: "",
      description: "",
      status: "",
      city: "",
      citylist: [],
      statuslist: [
        { value: "verified", label: "verified" },
        { value: "pending", label: "Pending" },
        { value: "blocked", label: "blocked" },
      ],
      loading: false,
    };
    this.pathname = "auth/signup";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
    this.prepareData();
  }
  async prepareData() {
    let responseuni = await this.engine.getItemlistDirect("cities");
    if (responseuni) {
      const data = responseuni.data.items;
      let citylist = [];
      data.map((p) => {
        citylist.push({ value: p.id, label: p.name });
      });
      this.setState({
        citylist,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, ...data } = this.state;
    let response;

    if (id) {
      response = await this.engine.updateItem("users", id, data);
    } else {
      response = await this.engine.saveItem(this.pathname, data);
    }

    if ((response && response.status === 201) || response.status === 200) {
      this.props.history.push("/admin/users");
    }

    this.setState({ loading: false });
  };

  render() {
    // taking all the states
    const {
      loading,
      isLoading,
      lastName,
      firstName,
      email,
      status,
      statuslist,
      id,
      password,
      phonenumber,
      city,
      citylist,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }
    return (
      <>
        <div className="content english">
          <h4></h4>
          <Row>
            <Col md="12">
              <AvForm
                onValidSubmit={() => this.handleValidSubmit()}
                className="form-horizontal"
                id="TypeValidation"
              >
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">{strings.information}</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormRow
                      label={strings.firstname}
                      name="firstName"
                      data={firstName}
                      changeInput={this.changeInput.bind(this)}
                    />
                    <FormRow
                      label={strings.lastname}
                      name="lastName"
                      data={lastName}
                      changeInput={this.changeInput.bind(this)}
                    />
                    <FormRow
                      label={strings.email}
                      name="email"
                      data={email}
                      changeInput={this.changeInput.bind(this)}
                    />
                    <FormRow
                      label={strings.phone}
                      name="phoneNumber"
                      data={phonenumber}
                      changeInput={this.changeInput.bind(this)}
                    />
                    {!id && (
                      <SelectRow
                        label={strings.city}
                        name="cityId"
                        defaultValue={city}
                        data={citylist}
                        changeInput={this.changeInput.bind(this)}
                      />
                    )}

                    {id && (
                      <SelectRow
                        label={strings.status}
                        name="status"
                        defaultValue={status}
                        data={statuslist}
                        changeInput={this.changeInput.bind(this)}
                      />
                    )}
                  </CardBody>

                  <CardFooter className="text-center">
                    <ButtonLoader color="primary" loading={loading}>
                      {strings.save}
                    </ButtonLoader>
                  </CardFooter>
                </Card>
              </AvForm>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
